<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_managetransferrole/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
